import React, { useState } from "react"
import styles from "./question.module.css"
import { checkAnswer } from "../utils/quizUtil"

export default props => {
  const [userAnswer, setUserAnswer] = useState("")
  const { qid, type, answer, answered, handleClick } = props
  const disabled = userAnswer.length === 0 || answered
  const qParams = { type, answer, userAnswer }
  let inputStyles = [styles.input]

  if (answered) {
    const isCorrect = checkAnswer(qParams)

    if (isCorrect) {
      inputStyles.push(styles.correct)
    } else {
      inputStyles.push(styles.incorrect)
    }
  }

  return (
    <>
      <input
        type="text"
        value={userAnswer}
        disabled={answered}
        placeholder="Type your answer here"
        onChange={e => setUserAnswer(e.target.value)}
        className={inputStyles.join(" ")}
      />
      <button
        type="button"
        disabled={disabled}
        onClick={() => {
          handleClick(qid, qParams)
        }}
        onKeyDown={() => {
          handleClick(qid, qParams)
        }}
        className={
          (disabled && styles.submit) ||
          [styles.submit, styles.enabled].join(" ")
        }
      >
        Submit
      </button>
    </>
  )
}
